(async () => {
    const { Core } = await importModule('Core');

    const {
        $hide
    } = await importModule('Utils');

    customElements.define('announcement-bar', class extends Core {
        elements = {
            closeButton:  '[data-close]'
        }

        render() {
            // Initial visibility is now handled synchronously inline in
            // sections/g_announcement-bar.liquid, before first paint, so this
            // deferred module only needs to own the close-button interaction.
            this.$closeButton?.addEventListener('click', () => {
                window.sessionStorage.setItem('hideAnnouncement', 'true');
                $hide(this);
            })
        }
    })
})();